import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Container, Button, Fade } from '@mui/material';
import { Formik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DashboardHeader from '../../../components/Dashboard/DashboardHeader';
import DashboardMenu from '../../../components/Dashboard/DashboardMenu';
import Footer from '../../../components/Footer';
import { MainWrapper } from './style';
import AppointmentInfoCard from '../../../components/Appointments/AppointmentCreate/AppointmentInfoCard';
import AppointmentAvailabilityCard from '../../../components/Appointments/AppointmentCreate/AppointmentAvailabilityCard';
import { PrimaryButton } from '../../../utils/theme';
import AppointmentErrorModal from '../../../components/Appointments/AppointmentCreate/AppointmentErrorModal';
import Loading from '../../../components/global/Loading';
import { Mixpanel, MIXPANEL_TAGS } from '../../../utils/mixpanel';

const AppointmentDetail = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();
  const [loading] = useState(false);

  const redirectToEditAppointment = () => history.push('/appointments/create');

  const redirectToScheduleAppointment = () => history.push(`/appointments/schedule/${params.id}`);

  useEffect(() => {
    Mixpanel.track(MIXPANEL_TAGS.APPOINTMENT_DETAIL_VIEW);
    dispatch.Appointments.serviceDetail(params.id);
  }, []);

  return (
    <MainWrapper>
      <DashboardHeader />
      <DashboardMenu />
      <AppointmentErrorModal />
      {loading ? (
        <Grid
          container
          spacing={0}
          direction='column'
          alignItems='center'
          justifyContent='center'
          style={{ minHeight: '70vh' }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Loading />
          </Grid>
        </Grid>
      ) : (
        <Container disableGutters style={{ marginBottom: 120, maxWidth: '1240px' }}>
          <Grid container alignItems='center' justifyContent='flex-end'>
            <Button onClick={redirectToEditAppointment} variant='outlined' startIcon={<EditIcon />} sx={{ color: '#6B48FF', borderColor: '#6B48FF', marginRight: '10px', borderRadius: '20px' }}>Editar</Button>
            <PrimaryButton onClick={redirectToScheduleAppointment} startIcon={<CalendarTodayIcon />}>Agendar novo compromisso</PrimaryButton>
          </Grid>

          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={{}}
            onSubmit={{}}
            validationSchema={{}}
          >
            {({ ...formikProps }) => (
              <Grid
                container
                justifyContent='center'
                spacing={1}
              >
                <Fade in>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <AppointmentInfoCard readOnly {...formikProps} />
                  </Grid>
                </Fade>

                <Fade in>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <AppointmentAvailabilityCard readOnly />
                  </Grid>
                </Fade>
              </Grid>
            )}
          </Formik>
        </Container>
      )}

      <Footer />
    </MainWrapper>
  );
};

export default AppointmentDetail;
